const routes = [
  {
    path: '/promo-code',
    name: 'PromoCodePage',
    duckName: 'PromoCodePage',
    loaders: {
      page: () => import('./containers/PromoCodePage/PromoCodePage'),
      duck: () => import('./ducks/PromoCodePage.duck'),
    },
    auth: true,
  },
  {
    path: '/promo-code/:id',
    name: 'EditPromoCodePage',
    duckName: 'EditPromoCodePage',
    loaders: {
      page: () => import('./containers/EditPromoCodePage/EditPromoCodePage'),
      duck: () => import('./ducks/EditPromoCodePage.duck'),
    },
    auth: true,
  },
];

export default routes;
